import React, { useEffect, useState } from 'react';
import dataProvider from '../../../providers/dataProvider';
import { Box, Card, Button } from '@material-ui/core';

import AddIcon from '@material-ui/icons/AddCircleOutline';
import SubscriptionBoostRow from './SubscriptionBoostRow';

import './styles.css';
import { SubscriptionBoost } from './types';

type SubscriptionBoostError = Partial<Record<keyof SubscriptionBoost, string>>;

const DEFAULT_BOOST: SubscriptionBoost = {
  isActive: true,
  title: '',
  source: 'ALL',
  label: '',
  subscriptionCost: 1,
  boostCost: 0,
  boostTickets: 0,
  boostDiscount: '',
};

const SubscriptionsBoostTab = () => {
  const [boosts, setBoosts] = useState<SubscriptionBoost[]>([]);
  const [errors, setErrors] = useState<SubscriptionBoostError[]>([]);
  const [generalId, setGeneralId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    console.log('boosts: ', boosts);
  }, [boosts]);

  const init = async () => {
    const res = await dataProvider.getGeneral();
    const data = res.data;

    if (data?.subscriptionsBoost) {
      setBoosts(data.subscriptionsBoost);
      setGeneralId(data._id);
    }
  };

  const NUMBER_FIELDS: (keyof SubscriptionBoost)[] = [
    'subscriptionCost',
    'boostCost',
    'boostTickets',
  ];

  const updateBoost = React.useCallback(
    <K extends keyof SubscriptionBoost>(
      index: number,
      field: K,
      value: SubscriptionBoost[K],
    ) => {
      let parsedValue = value;

      if (NUMBER_FIELDS.includes(field)) {
        parsedValue = (
          value === '' ? 0 : Number(value)
        ) as SubscriptionBoost[K];
      }

      setBoosts((prev) => {
        const copy = [...prev];
        copy[index] = { ...copy[index], [field]: parsedValue };
        return copy;
      });
    },
    [],
  );

  const addBoost = () => {
    setBoosts((prev) => [...prev, { ...DEFAULT_BOOST }]);
  };

  const removeBoost = (index: number) => {
    setBoosts((prev) => prev.filter((_, i) => i !== index));
  };

  const validate = () => {
    const newErrors: SubscriptionBoostError[] = boosts.map((b, i) => {
      const err: SubscriptionBoostError = {};

      // if (!b.title) err.title = 'Required';
      if (!b.boostDiscount) err.boostDiscount = 'Required';
      if (b.subscriptionCost <= 0) err.subscriptionCost = 'Must be > 0';

      // const duplicate = boosts.find(
      //   // (x, idx) => x.orderCost === b.orderCost && idx !== i,
      //   (x, idx) =>
      //     x.orderCost === b.orderCost &&
      //     b.orderType === x.orderType &&
      //     idx !== i,
      // );

      // if (duplicate) err.orderCost = 'Must be unique';

      return err;
    });

    setErrors(newErrors);
    return newErrors.every((e) => Object.keys(e).length === 0);
  };

  const save = async () => {
    if (!generalId || !validate()) return;

    setIsLoading(true);
    try {
      console.log('PAYLOAD: ', boosts);
      await dataProvider.updateGeneral({
        id: generalId,
        data: { subscriptionsBoost: boosts },
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleChange = updateBoost;
  return (
    <Card className='tabCardWrapper orders-boost'>
      <h3>Subscriptions Boost</h3>

      {boosts.map((boost, i) => (
        <SubscriptionBoostRow
          key={i}
          boost={boost}
          index={i}
          errors={errors[i]}
          onChange={handleChange}
          onRemove={removeBoost}
        />
      ))}

      {/* ADD */}
      <Box mt={2}>
        <Button startIcon={<AddIcon />} onClick={addBoost}>
          Add boost
        </Button>
      </Box>

      {/* SAVE */}
      <Box mt={2}>
        <Button
          variant='contained'
          color='primary'
          onClick={save}
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Box>
    </Card>
  );
};

export default SubscriptionsBoostTab;
